import { render, staticRenderFns } from "./PortfolioComponent.vue?vue&type=template&id=1158849f&scoped=true&"
import script from "./PortfolioComponent.vue?vue&type=script&lang=ts&"
export * from "./PortfolioComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioComponent.vue?vue&type=style&index=0&id=1158849f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1158849f",
  null
  
)

export default component.exports